<div class="card" rte="h5">
    <h1 rte="h6">Static Pages</h1>
    <grid [tableSettings]="tableSettings" [gridSettings]="gridSettings" rte="1gw"></grid>
</div>